import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
} from "constants/FormatDataContanst";

export const getReportStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: t("auth_status_report.m"),
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: t("auth_status_report.p"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: t("auth_status_report.a"),
      badgeColor: "badge-soft-success",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};
